// Production constants for the admin Receipt feature (NOT dummy scaffolding; these
// survive when dummyData.js is deleted once the backend endpoint exists).

// Digital Receipt rides on two card-network programs: Consumer Clarity on Ethoca
// (Mastercard) and Order Insight on Verifi (Visa). Brand glyph comes from the Images
// map (same keys the merchant Deflect page uses; there is no `ethoca` icon).
export const PROGRAM_META = {
  ethoca: { label: "Ethoca", program: "Consumer Clarity", img: "mastercard" },
  verifi: { label: "Verifi", program: "Order Insight", img: "verifi" }
}
